import React from "react"
import CarStockList from "./CarStockList"

// Default allowed keys
const defaultAllowedKeys = [
  "brand",
  "model",
  "engine_type",
  "year",
  "exterior_color",
  "package",
  "auction_grade",
  "location",
  "status",
  "importer",
  "paginate",
  "group_per_page",
  "vehicle_sort",
  "search",
]

const CarStockWrapper = ({
  btn = { color: "info" },
  allowedKeys = [], // parent can override
  renderTrigger,
  ...params
}) => {
  const allowedParams = [...allowedKeys, ...defaultAllowedKeys]
  // Detect invalid/unallowed params
  const invalidParams = Object.keys(params).filter(
    key => !allowedParams.includes(key)
  )

  // Configure button props
  const btnProps =
    invalidParams.length > 0
      ? {
          color: "secondary",
          disabled: true,
          title: `Cannot proceed: invalid filter${
            invalidParams.length > 1 ? "s" : ""
          } detected: ${invalidParams.join(", ")}`,
        }
      : btn

    // console.log("All params:", params)
    // console.log("Invalid params:", invalidParams)
    // console.log("Button props:", btnProps)

  return <CarStockList {...params} btn={btnProps} renderTrigger={renderTrigger} />
}

export default CarStockWrapper
